module.exports = __webpack_public_path__ + "img/contact_point_1.55a63912.png";